module.exports = __webpack_public_path__ + "img/oldmail-01@3x.ad6a1edb.png";